import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Customer, CustomerExtended } from '../model/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerApiService {

  constructor(private httpClient: HttpClient) { }

  private baseReportsUrl = `${environment.reportsApiUrl}/customers`;

  customerSearch(restaurantId: number, value: string, filter: 'surname' | 'telephone'): Observable<{ customerDetails: Customer[] }> {
    return this.httpClient.post<{ customerDetails: Customer[] }>(`${this.baseReportsUrl}/search`, { restaurantId, value, filter }).pipe(
      map((res: { customerDetails: Customer[] }) => {
        return res;
      })
    );
  }

  guestSearch(restaurantId: number, value: string, filter: 'surname' | 'telephone'  | 'roomNo' | 'bookingNo'): Observable<{ customerDetails: Customer[] }> {
    return this.httpClient.post<{ customerDetails: Customer[] }>(`${this.baseReportsUrl}/search`, { restaurantId, value, filter }).pipe(
      map((res: { customerDetails: CustomerExtended[] }) => {
        return res;
      })
    );
  }
}
